export const sizes = {
  min_mobile: 'min-width: 300px',
  max_mobile: 'max-width: 767.98px',
  min_tablet: 'min-width: 768px',
  max_tablet: 'max-width: 1199.98px',
  desktop: 'min-width: 1200px',
  large_desktop: 'min-width: 1441px',
  b_desktop: 'min-width: 1921px',
};
